import React, { useState, useEffect } from 'react';
import registeredComponent from "utils/registeredComponent";
import { compose } from 'redux';
import duckify, { singleDuck } from '../../utils/duckify';
import { forms, modals } from '../../ducks';
import Placeholder from '../Placeholder';
import OrderForm from '../payments/OrderForm';
import FeeList from '../payments/FeeList';

const FormPayment = ({
  form,
  form_type,
  entity_payment_method,
  entity_supported_payment_methods,
  pay_now,
  autopay,
  manual_payment_url,
  updatePaymentMethod,
  allDucksReady,
  dispatch
}) => {
  const [fees, setFees] = useState([]);
  const [feeTotal, setFeeTotal] = useState(0);
  const [convenienceFee, setConvenienceFee] = useState(0);
  const [formCompleted, setFormCompleted] = useState(false);
  const [completedFirstLoad, setCompletedFirstLoad] = useState(false);

  useEffect(() => {
    if (!form) return;
    setFormCompleted(entity_payment_method !== null);

    if (!form.form_fees || completedFirstLoad) return;
    setFees(form.form_fees);
    setConvenienceFee(form.convenience_fee);
    setFeeTotal(Number(form.fee_total));
    setCompletedFirstLoad(true);
  }, [form]);

  return (
    <Placeholder.loading ready={allDucksReady} content={() => {
      return <div className="form-payment">
        <div className="fee-section">
          <h3>Fees</h3>
          <FeeList fees={fees.map(fee => ({
            description: fee.name,
            amount: fee.amount
          }))}/>
        </div>

        <div className="payment-section">
          <h3>Payment Info</h3>
          {formCompleted ? (
            <p>Thank you, we have received payment for this form via {entity_payment_method}.</p>
          ) : (
            <OrderForm
              order={{
                entity_id: form.id,
                entity_class: form_type,
                pay_now: pay_now
              }}
              payNow={pay_now}
              manualPaymentUrl={manual_payment_url}
              showAutopayOption={autopay}
              amount={feeTotal}
              beforeChange={(payment_method, payment_profile_id) => {
                return updatePaymentMethod({
                  ...form,
                  form_type,
                  payment_method,
                  payment_profile_id
                }).then(response => {
                  if (response && response.result) {
                    setFees(response.result.fees);
                    setFeeTotal(Number(response.result.fee_total));
                  }
                }).catch(error => {
                  if (error && error.message) {
                    dispatch(modals.actions.show('UnexpectedError', {message: error.message}));
                  } else {
                    dispatch(modals.actions.show('UnexpectedError'));
                  }
                });
              }}
              disabled={feeTotal <= 0}
              paymentMethods={entity_supported_payment_methods}
              convenienceFee={convenienceFee && convenienceFee.amount ? Number(convenienceFee.amount) : 0}
              selectedPaymentMethod={entity_payment_method}
              selectedPaymentProfileId={form.payment_profile_id}
            />
          )}
        </div>
      </div>
    }}/>
  )
};

const mapDucksToProps = ({form_id, form_type}) => ({
  form: singleDuck( forms, form_id, { form_type: form_type } )
});

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch, props) => ({
  updatePaymentMethod: (form) => dispatch(forms.actions.updatePaymentMethod(form))
});

export default registeredComponent('FormPayment')(duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FormPayment));
